/**
 * Static route paths
 *
 */

export const PROJECT_ROUTE_NAME = 'work';
export const ALL_PROJECTS_ROUTE_NAME = 'all-work';
export const E404_ROUTE_NAME = 'not-found';
